import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useBrand } from '../../hooks/useBrand';
import { StatGroup } from '../shared/StatGroup';
import { handleImgError } from '../../utils/imageUtils';
import type { BrandContent } from '../../data/brandContent';
interface VendorCTASectionProps {
  content: BrandContent['vendorCta'];
}

/** Author/vendor recruitment panel. Copy and metrics are passed in. */
export const VendorCTASection: React.FC<VendorCTASectionProps> = ({
  content
}) => {
  const dk = useDarkClasses();
  const {
    theme
  } = useBrand();
  return <section className={`py-16 ${dk.page}`} data-id="element-1905" data-mp="2qr1y559ph9nu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1906" data-mp="2urc2kdhuns0l">
        <div className={`${theme.vendorCta.panel} rounded-2xl shadow-xl overflow-hidden`} data-id="element-1907" data-mp="oxccg6dpuxgb">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1908" data-mp="synyk1xdt0jr">
            <div className="p-8 md:p-12 text-white flex flex-col justify-center" data-id="element-1909" data-mp="swtkn7kj28p6">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1910" data-mp="1objgwj4vaf7u">
                {content.title}
              </h2>
              <p className="text-lg opacity-90 mb-8 max-w-lg" data-id="element-1911" data-mp="1jbyetzuehqqw">
                {content.description}
              </p>

              <StatGroup stats={content.stats} className="mb-8" data-id="element-1912" data-mp="1t3ue3e883mwp" />

              <ul className="space-y-3 mb-8" data-id="element-1913" data-mp="1t4mausdk3qok">
                {content.features.map(item => <li key={item} className="flex items-center" data-id="element-1914" data-mp="15ei9ysrr6519">
                    <div className={`${theme.vendorCta.check} rounded-full p-1 mr-3`} data-id="element-1915" data-mp="10fyhsamkfx0g">
                      <CheckCircleIcon className="h-4 w-4" data-id="element-1916" data-mp="1fdqzn9fl4xht" />
                    </div>
                    <span className="font-medium" data-id="element-1917" data-mp="1acjnyzabne5v">{item}</span>
                  </li>)}
              </ul>
              <div data-id="element-1918" data-mp="2qtpe5stj8bqf">
                <Link to="/vendor/signup" className={`inline-block font-bold px-8 py-4 rounded-lg transition-colors shadow-lg ${theme.vendorCta.button}`} data-id="element-1919" data-mp="2lsi6ruvaxeka">
                  {content.buttonLabel}
                </Link>
              </div>
            </div>
            <div className="hidden lg:flex flex-col" data-id="element-1920" data-mp="32u5ihn8vglhv">
              <div className="h-2/3 relative" data-id="element-1921" data-mp="32uf99d1qqwom">
                <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Author writing" className="absolute inset-0 h-full w-full object-cover" onError={handleImgError} data-id="element-1922" data-mp="37sp4tordnzar" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-1923" data-mp="2k2d00mrfiioe" />
              </div>
              <div className="h-1/3 bg-black/40 backdrop-blur-sm p-8 flex items-center justify-center" data-id="element-1924" data-mp="2ovfoighcn1xq">
                <blockquote className="text-white max-w-md" data-id="element-1925" data-mp="1rcmjk72br4p4">
                  <p className="text-lg italic mb-4" data-id="element-1926" data-mp="1wcs6xb1ka51e">"{content.quote}"</p>
                  <footer className="flex items-center" data-id="element-1927" data-mp="dj7gs3xwq4ql">
                    <div className="w-10 h-10 rounded-full bg-gray-300 overflow-hidden mr-3 border-2 border-white/20" data-id="element-1928" data-mp="dgl8u373tn7u">
                      <img src="https://i.pravatar.cc/100?img=44" alt="" className="w-full h-full object-cover" data-id="element-1929" data-mp="4i0wrkw1ubsl" />
                    </div>
                    <div data-id="element-1930" data-mp="3qph7lu0rilps">
                      <div className="font-bold text-sm" data-id="element-1931" data-mp="3qqsbruy4dvhf">
                        {content.quoteAuthor}
                      </div>
                      <div className="text-xs opacity-70" data-id="element-1932" data-mp="3lwo419h15jfa">
                        {content.quoteRole}
                      </div>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};